export default function PlusIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 11H18V13H13V18H11V13H6V11H11V6H13V11Z" fill="#3C3C3C" />
    </svg>
  );
}
